const EVENT_HOME_DELIVERY = 'event-home-delivery';

const homeDeliveryEventTrigger = () => {
	document.querySelectorAll('.js-delivery-type-selector-home').forEach(
      radio => {
        radio.addEventListener('change', () => {
          if (radio.checked) {
            const event = new CustomEvent(EVENT_HOME_DELIVERY);
            event.action = 'home_delivery';
		        document.dispatchEvent(event);
          }
        })
      });
};

export {EVENT_HOME_DELIVERY, homeDeliveryEventTrigger};